import "whatwg-fetch";
import Globals from "@/components/globals";
import { store } from "@/store/store";
import { clearLocalStorage } from "@/utils/storage";
import cacheService from "@/services/cache";
import { redirectToLogin } from "@/services/http";

// @deprecated, use "@/services/http"; instead
export default {
    _killCache(url) {
        let r = Math.floor(Math.random() * 100000);
        return url + ((url.indexOf("?") > 0 ? "&" : "?") + "cache=" + r);
    },
    getToken() {
        let oUser = cacheService.getRem3rchUser();
        let token = null;
        if (oUser !== null && oUser.hasOwnProperty("token")) {
            token = oUser.token;
        }
        return token;
    },
    checkStatus(response) {
        let results = response.json();
        results.then(result => {
            // The user is not authenticated (anymore) -> redirect to login
            if (parseInt(result.code) === 401) {
                redirectToLogin(); // Redirection vers -> /login?redirect=token
            } else if (parseInt(result.code) === 428) {
                store.dispatch("cguStore/setCguStatus", false);
                store.dispatch("cguStore/setShown", true);
                throw new Error();
            }
        });

        return results;
    },
    fetch(paramMethod, paramUrl, paramBody, flag = false, rawUrl = false, withouCampaign = false, infos = {}, returnPromise = false, root = false) {
        if (this.getToken() === null && !window.location.pathname.match("^/login")) {
            window.location = "/login?redirect";
        }
        let brandId = infos.brandId || cacheService.getCurrentBrandId();
        let zoneId = infos.zoneId || cacheService.getCurrentZoneId();
        let campaignId = infos.campaignId || withouCampaign ? 0 : cacheService.getCurrentCampaignId();

        let hasBrandValid = !(brandId === undefined || brandId === null || brandId === "undefined");
        let hasZoneValid = !(zoneId === undefined || zoneId === null || zoneId === "undefined");
        if (hasBrandValid === false || hasZoneValid === false) {
            return new Promise((resolve, reject) => {
                let message = "On ne peut pas faire l'appel api car la zone ou la marque n'est pas définie";
                console.error(message);
                clearLocalStorage();
                resolve({ error: 800, messaqe: message });
            });
        }
        let url = Globals.getBackHost() + "/" + brandId + "/" + zoneId + (campaignId > 0 ? "/" + campaignId : "") + paramUrl;
        if (flag) {
            url = Globals.getBackHost() + "/" + brandId + "/" + paramUrl;
        }
        if (root) {
            url = Globals.getBackHost() + "/" + paramUrl;
        }
        if (paramUrl.match("^/logout")) {
            url = Globals.getBackHost() + "/logout";
        }
        let self = this;
        let oContent = {
            method: paramMethod,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: this.getToken()
            },
            body: paramBody
        };
        if (paramMethod === "GET" || paramMethod === "DELETE") {
            delete oContent.body;
        }

        if (paramMethod === "UPLOAD") {
            // reset conf request when upload files
            url = Globals.getBackHost() + "/" + brandId + "/" + zoneId + paramUrl;
            if (root) {
                url = Globals.getBackHost() + "/" + paramUrl;
            }
            oContent = {
                method: "post",
                headers: {
                    Authorization: this.getToken()
                },
                body: paramBody
            };
        }
        if (rawUrl) {
            url = paramUrl;
        }
        if (returnPromise) {
            return fetch(url, oContent);
        }
        return fetch(url, oContent)
            .then(self.checkStatus)
            .then(function(data) {
                return data;
            });
    },
    get(paramUrl, paramBody) {
        return this.fetch("GET", paramUrl, paramBody);
    },
    getWithCustomInfo(paramUrl, paramBody, infos = {}) {
        return this.fetch("GET", paramUrl, paramBody, null, null, false, infos);
    },
    getWithoutCampaign(paramUrl, paramBody) {
        return this.fetch("GET", paramUrl, paramBody, null, null, true);
    },
    post(paramUrl, paramBody) {
        return this.fetch("POST", paramUrl, paramBody);
    },
    postWithoutCampaign(paramUrl, paramBody) {
        return this.fetch("POST", paramUrl, paramBody, null, null, true);
    },
    put(paramUrl, paramBody) {
        return this.fetch("PUT", paramUrl, paramBody);
    },
    putWithoutCampaign(paramUrl, paramBody) {
        return this.fetch("PUT", paramUrl, paramBody, null, null, true);
    },
    delete(paramUrl, paramBody) {
        return this.fetch("DELETE", paramUrl, paramBody);
    },
    deleteWithoutCampaign(paramUrl, paramBody) {
        return this.fetch("DELETE", paramUrl, paramBody, null, null, true);
    },
    checkDuplicate(paramUrl, paramBody, flag = true) {
        return this.fetch("GET", paramUrl, paramBody, flag);
    },
    upload(url, formData) {
        return this.fetch("UPLOAD", url, formData);
    },
    putFormData(url, formData) {
        return this.fetch("PUT", url, formData);
    },
    hasError(response) {
        let knownCodeErrors = [400, 404, 428];
        for (let error of knownCodeErrors) {
            if (response.code === error || response.code === error.toString() || response.status === error || response.code === status.toString()) {
                return true;
            }
        }
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/components/service.js